export function roundDecimals(
  numberToRound: number,
  noOfDecimals: number
): number {
  const roundingHelper = Math.pow(10, noOfDecimals);
  return (
    Math.round((numberToRound + Number.EPSILON) * roundingHelper) /
    roundingHelper
  );
}
